import React, { useMemo } from "react";
import {
  Autocomplete,
  Checkbox,
  ListItemText,
  MenuItem,
  Popper,
  TextField,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const GCAutocompleteCheckboxFixSizeUid = ({
  options = [],
  xValue = [],
  xtabIndex = "",
  xDisabled = false,
  label,
  placeholder,
  setValue
}) => {
  // ✅ Always use safe array
  const safeXValue = Array.isArray(xValue) ? xValue : [];

  const allOptions = useMemo(
    () => [{ Uid: "select-all", Name1: "Select All" }, ...options],
    [options]
  );

  const isAllSelected =
    safeXValue.length > 0 &&
    options.length > 0 &&
    safeXValue.length === options.length;

  const handleChange = (event, newValue) => {
    if (!Array.isArray(newValue)) return;

    const hasSelectAll = newValue.some((item) => item.Uid === "select-all");

    if (hasSelectAll) {
      if (isAllSelected) {
        setValue([]);
      } else {
        const allUIDs = options.map((item) => item.Uid);
        setValue(allUIDs);
      }
    } else {
      const selectedUIDs = newValue.map((item) => item.Uid);
      setValue(selectedUIDs);
    }
  };

  const isSelected = (option) => safeXValue.includes(option.Uid);

  return (
    <div
      className="GCAutocompleteCheckboxFixSize"
      style={{ background: xDisabled ? "#e9ecef" : "transparent" }}
    >
      <Autocomplete
        tabIndex={xDisabled ? "" : xtabIndex}
        disabled={xDisabled}
        multiple
        size="small"
        options={allOptions}
        getOptionLabel={(option) => option?.Name1 || ""}
        value={allOptions.filter((grp) =>
          safeXValue.includes(grp.Uid)
        )}
        isOptionEqualToValue={(option, value) => option.Uid === value.Uid}
        onChange={handleChange}
        disableCloseOnSelect
        PopperComponent={(props) => (
          <Popper
            {...props}
            style={{
              zIndex: 1300,
              width: props.anchorEl ? props.anchorEl.clientWidth : "auto",
            }}
            placement="bottom-start"
          />
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
            sx={{
              fontSize: "12px",
              "& .MuiOutlinedInput-root": {
                maxHeight: "32px",
                overflowY: "auto",
                border: "1px solid #ddd",
                padding: "0px !important",
                minWidth: "0px !important",
              },
              "& .MuiAutocomplete-input": {
                padding: "7.5px 4px 7.5px 5px !important",
              },
            }}
          />
        )}
        renderOption={(props, option, { selected }) => {
          const isThisSelected = isSelected(option);
          if (option.Uid === "select-all") {
            return (
              <MenuItem
                {...props}
                sx={{
                  height: "31px",
                  minHeight: "31px",
                  padding: "0 8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Checkbox
                  size="small"
                  checked={isAllSelected}
                  indeterminate={
                    safeXValue.length > 0 && safeXValue.length < options.length
                  }
                />
                <ListItemText
                  primary="Select All"
                  primaryTypographyProps={{
                    fontSize: "12px",
                    lineHeight: "1.2",
                  }}
                />
              </MenuItem>
            );
          }
          return (
            <MenuItem
              {...props}
              sx={{
                height: "31px",
                minHeight: "31px",
                padding: "0 8px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Checkbox size="small" checked={isThisSelected} />
              <ListItemText
                primary={option?.Name1}
                primaryTypographyProps={{
                  fontSize: "12px",
                  lineHeight: "1.2",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              />
            </MenuItem>
          );
        }}
      />
    </div>
  );
};


export default GCAutocompleteCheckboxFixSizeUid;
